import {Directive, HostBinding, Input} from '@angular/core';

@Directive({
    selector: '[apptheme]' // Attribute selector
})
export class AppTheme {

    @HostBinding('class')
    @Input() elementClass:string = '';

    themeClass = {
        0: 'default-theme',
        1: 'regisafe-theme'
    };

    constructor() {
        let apptheme = localStorage.getItem('settings.apptheme');
        if(apptheme != '0') {
            this.elementClass = this.themeClass[1];
        } else {
            this.elementClass = this.themeClass[0];
        }
    }
}



// WEBPACK FOOTER //
// ./src/apptheme/apptheme.ts